import { useEffect } from 'react';
import { getAuthService } from '../ports/auth-service.registry';
import { backendAuthService } from '../services/backend-auth.service';
import { useAuthStore } from '../stores/authStore';

export function useAuthInitialization(): {
  isInitialized: boolean;
  isLoading: boolean;
} {
  const setUser = useAuthStore((state) => state.setUser);
  const setToken = useAuthStore((state) => state.setToken);
  const setInitialized = useAuthStore((state) => state.setInitialized);
  const setLoading = useAuthStore((state) => state.setLoading);
  const logout = useAuthStore((state) => state.logout);
  const isInitialized = useAuthStore((state) => state.isInitialized);
  const isLoading = useAuthStore((state) => state.isLoading);

  useEffect(() => {
    const authService = getAuthService();
    const unsubscribe = authService.onAuthStateChanged(async (authUser) => {
      if (!authUser) {
        logout();
        setInitialized(true);
        return;
      }

      try {
        setLoading(true);
        const token = await authService.getIdToken();
        if (!token) throw new Error('Failed to get token');

        const response = await backendAuthService.authenticate(token);
        setUser(response.user);
        setToken(token);
      } catch {
        logout();
      } finally {
        setLoading(false);
        setInitialized(true);
      }
    });

    return () => unsubscribe();
  }, [setUser, setToken, setInitialized, setLoading, logout]);

  return { isInitialized, isLoading };
}
